import {GET_MENU_BADGE_COUNTER, GET_MENU_TOTAL_BADGE_COUNTER} from "@/core/store/modules/notification/constants";

export default {
    [GET_MENU_TOTAL_BADGE_COUNTER]: (state) => (group) => {
        let sum = 0
        let keys = []
        if (group === 'blog') {
            keys = ['blog_comments']
        }

        keys.forEach(item => {
            if (state.menu_badge_counter && state.menu_badge_counter[item]) {
                sum += state.menu_badge_counter[item]
            }
        })

        return sum;
    },
    [GET_MENU_BADGE_COUNTER]: (state) => (key) => {
        return state.menu_badge_counter && state.menu_badge_counter[key] ? state.menu_badge_counter[key] : 0
    }
}